import { render, staticRenderFns } from "./VendorInvoicePaymentDetails.vue?vue&type=template&id=c6009164"
import script from "./VendorInvoicePaymentDetails.vue?vue&type=script&lang=js"
export * from "./VendorInvoicePaymentDetails.vue?vue&type=script&lang=js"
import style0 from "./VendorInvoicePaymentDetails.vue?vue&type=style&index=0&id=c6009164&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports